/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Injectable } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { LookupList } from 'app/shared/models/lookup-list.model';
import { IAutoCompleteAddListModel } from '../models/auto-complete-add-list.model';

@Injectable({providedIn: 'root'})
export class ReactiveFormHelperService {

  constructor() { }


  public markFormControlTouched(group) {
    if (!(group instanceof FormArray) && !(group instanceof FormGroup)) {
      return;
    }

    const vals = Object.keys(group.controls).map(x => group.controls[x])

    vals.forEach(control => {

      if (control && !(control instanceof FormArray)) {
        control.markAsTouched();
      }
      if (control.controls) {
        control.controls.forEach(c => this.markFormControlTouched(c));
      }
    });
  }

  public isFormValid(dataForm: FormGroup, touchAllControls: boolean = true) {

    if (dataForm == null) {
      return false;
    }

    if (touchAllControls) {
      this.markFormControlTouched(dataForm);
    }
        
    return dataForm.valid;    
  }

  public isFormDirty(dataForm: FormGroup) {
    if (dataForm == null) {
      return false;
    }
    return dataForm.dirty;
  }

  createLookupData(list: LookupList): any[] {
    return list.items.map(item => {
      return {
        id: item.id, 
        text: item.name,
        // sublists: item.subLists.map(sublist=>{return this.createLookupData(sublist)})
      }});
  }
  
  createLookupDataWithSubLists(list: LookupList): any[] {
    return list.items.map(item => {
      return {
        id: item.id, 
        text: item.name,
        sublists: item.subLists.map(sublist => this.createLookupData(sublist))
      }});
  }
  
  createLookupDataWithSubListsAndDataObject(list: LookupList): any[] {
    return list.items.map(item => {
      return {
        id: item.id, 
        text: item.name,
        sublists: item.subLists.map(sublist => this.createLookupDataWithDataObject(sublist))
      }});
  }

  createLookupDataWithDataObject(list: LookupList): any[] {
    return list.items.map((item) => {
      return {
        id: +item.id,
        text: item.name,
        data: item.data,
      };
    });
  }

  createLookupDataWithDataObjectAndSublist(list: LookupList): any[] {
    return list.items.map((item) => {
      return {
        id: +item.id,
        text: item.name,
        data: item.data,
        sublists: item.subLists.map(sublist => this.createLookupData(sublist))
      };
    });
  }

  createLookupDataWithDataObjectAndSublistWithDataObject(list: LookupList): any[] {
    return list.items.map((item) => {
      return {
        id: +item.id,
        text: item.name,
        data: item.data,
        sublists: item.subLists.map(sublist => this.createLookupDataWithDataObject(sublist))
      };
    });
  }

  createLookupDataForAutocomplete(list: LookupList, excludedId: number): IAutoCompleteAddListModel[] {
    return list.items.filter(f=>f.id !== excludedId).map((item) => {
      return {
        itemId: +item.id,
        itemName: item.name,
        itemData: null,
        canDelete: true,
        cannotDeleteMessage: '',
        selected: false,
        hiddenWhenSelected: false
      };
    });
  }
}  


